import { key } from '@Constants/StateCurrent';

export function stateCurrent(state) {
  return state.get(key);
}

export function stateCurrentName(state) {
  return stateCurrent(state).get('name');
}
